import React, { useState } from "react";
import AuthenticationService from "../../../service/auth/AuthenticationService";
import EventService from "service/event/EventService";
import CommonService from "../../../modules/ops/modules/patients/modules/new-bridge/services/CommonService";
import PatientsService from "../../../modules/ops/modules/patients/service/PatientsService";
import Dialog from "@material-ui/core/Dialog";
import "./CallButton.scss";
import { FontIcon } from "react-md";
import { maskPhone } from "util/maskPhone";

function CallButton(props) {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [phoneDetails, setPhoneDetails] = useState([]);
  const [phoneNoIndex, setPhoneNoIndex] = useState(0);
  const [sparktgAgent, setSparktgAgent] = useState(1);

  const commonServices = new CommonService();
  const authenticationService = new AuthenticationService();
  const patientsService = new PatientsService();

  const employeeId = authenticationService.getUserProfile().employeeProfile.id;

  const callSparktg = () => {
    const phoneToCall = phoneDetails.find(
      (e) => e.index === phoneNoIndex,
    )?.phoneno;

    if (phoneToCall) {
      setLoading(true);
      const requestBody = {
        employeeId: employeeId,
        patientId: props.patient.id,
        phoneNo: phoneToCall,
      };
      const onResponse = () => {
        EventService.emit("showError", {
          message: "Phone call initiated !",
        });
        setTimeout(() => {
          setOpenDialog(false);
          setPhoneDetails([]);
          setLoading(false);
        }, 2000);
      };
      const onError = (error) => {
        EventService.emit("showError", {
          message: "Error while making the phone call: ",
          error,
        });
        setLoading(false);
      };
      commonServices.callSparktg(requestBody, onResponse, onError);
    } else {
      EventService.emit("showError", {
        message: "Invalid phone number",
      });
    }
  };

  const getAlternatePhoneNos = () => {
    setLoading(true);
    const onResponse = (response) => {
      if (response) {
        const alternatePhoneDetails = response.map((e, index) => ({
          index: index + 1,
          type: 2,
          phoneno: e.alternateNumber,
          countryCode: e.countryCode,
          description: e.description,
        }));

        setPhoneDetails((prev) => [...prev, ...alternatePhoneDetails]);
        setLoading(false);
      }
    };
    const onError = (error) => {
      EventService.emit("showError", {
        message: "Error in fetching alternate phone numbers: ",
        error,
      });
      setLoading(false);
    };
    patientsService.fetchAlternatePhoneNo(
      props.patient.id,
      onResponse,
      onError,
    );
  };

  const getSparktgAgent = () => {
    setLoading(true);
    const onResponse = (response) => {
      setSparktgAgent(response);
      setLoading(false);
    };
    const onError = (error) => {
      EventService.emit("showError", {
        message: "Error in fetching employee phone number from Sparktg: ",
        error,
      });
      setLoading(false);
    };
    commonServices.fetchSparktgAgent(employeeId, onResponse, onError);
  };

  const handleOpen = () => {
    setOpenDialog(true);
    setPhoneNoIndex(0);
    getSparktgAgent();
    setPhoneDetails([
      {
        index: 0,
        type: 1,
        phoneno: props.patient.phoneno,
        countryCode: props.patient.countryCode,
        description: "",
      },
    ]);
    getAlternatePhoneNos();
  };

  const handleClose = () => {
    setSparktgAgent(1);
    setOpenDialog(false);
    setPhoneDetails([]);
  };

  return (
    <div>
      <button className="call-btn-trigger" onClick={handleOpen}>
        <FontIcon style={{ color: "white" }}>phone</FontIcon>
        <span>Call</span>
      </button>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        PaperProps={{ className: "call-btn-dialog-paper" }}
      >
        <div className="call-btn-dialog">
          <div className="call-btn-dialog-header">
            <div className="call-btn-dialog-icon-wrapper">
              <FontIcon style={{ color: "grey", fontSize: "24px" }}>
                phone
              </FontIcon>
            </div>
            <h3 className="call-btn-dialog-title">
              Choose alternate calling number
            </h3>
          </div>

          {!sparktgAgent && (
            <div className="call-btn-dialog-error">
              Error in fetching agent from Sparktg!
            </div>
          )}
          {sparktgAgent && sparktgAgent === 1 && (
            <div className="call-btn-dialog-loading">
              Fetching agent from Sparktg...
            </div>
          )}

          <div className="call-btn-phone-list">
            {phoneDetails.map((e) => {
              const isPrimary = e.type === 1;
              const isSelected = phoneNoIndex === e.index;
              return (
                <label
                  key={e.index}
                  className={`call-btn-phone-item ${
                    isSelected ? "call-btn-phone-item--selected" : ""
                  }`}
                  onClick={() => setPhoneNoIndex(e.index)}
                >
                  <input
                    type="radio"
                    name="call-btn-phone-select"
                    checked={isSelected}
                    onChange={() => setPhoneNoIndex(e.index)}
                    className="call-btn-radio"
                  />
                  <div className="call-btn-phone-info">
                    <div className="call-btn-phone-description">
                      {e.description ||
                        (isPrimary
                          ? props.patient.name || "Primary"
                          : "Alternate")}
                    </div>
                    <div className="call-btn-phone-number">
                      {/* `maskNumbers` (the patient record) shows "+91 XXXXX
                          X3210"; the legacy cart keeps its full numbers. The
                          call itself always uses the stored number. */}
                      {props.maskNumbers
                        ? maskPhone(e.countryCode, e.phoneno)
                        : `${e.countryCode ? `+${e.countryCode} ` : ""}${e.phoneno}`}
                    </div>
                  </div>
                  <span
                    className={
                      isPrimary
                        ? "call-btn-badge call-btn-badge--primary"
                        : "call-btn-badge call-btn-badge--alternate"
                    }
                  >
                    {isPrimary ? "Primary" : "Alternate"}
                  </span>
                </label>
              );
            })}
          </div>

          <div className="call-btn-dialog-actions">
            <button
              className="call-btn-cancel"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className="call-btn-confirm"
              onClick={callSparktg}
              disabled={loading || !sparktgAgent || sparktgAgent === 1}
            >
              <FontIcon style={{ color: "white" }}>phone</FontIcon>
              Call
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default CallButton;
